import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v0/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v0/terrain-model';

export class TerrainModelService implements types.Handlers {
  private serviceEndpoint = '/terrain-model';

  constructor(private axios: AxiosInstance) {}

  async fetchTerrainModel({
    path: { geodataId },
  }: types.FetchTerrainModelParameters): Promise<types.TerrainModelResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${geodataId}`)).data;
  }

  async fetchSignRequestParameters({
    path,
  }: types.FetchSignRequestParametersParameters): Promise<common.SignedRequestResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${path.geodataId}/signed-request`)).data;
  }

  async calculateVolume({
    path,
    body,
  }: types.CalculateVolumeParameters): Promise<types.CalculateVolumeResponse> {
    return (
      await this.axios.post(`${this.serviceEndpoint}/${path.id}/volume`, {
        ...body,
      })
    ).data;
  }
  async deleteVolumeCalculation(
    params: types.DeleteVolumeCalculationParameters,
  ): Promise<types.SuccessResponse> {
    return (
      await this.axios.delete(
        `${this.serviceEndpoint}/${params.path.id}/volume/${params.path.volumeId}`,
      )
    ).data;
  }
  async fetchVolumeModelUrls(
    params: types.FetchVolumeModelUrlsParameters,
  ): Promise<common.DownloadUrlArrayResponse> {
    return (
      await this.axios.get(
        `${this.serviceEndpoint}/${params.path.id}/volume/${params.path.volumeId}/model-urls`,
      )
    ).data;
  }
}
